
import { encryptFernetSync, decryptFernetSync } from "./aesMsgpack"
import { ENCRYPT_KEY } from "../../constants"

/**
 * 加密
 * @param value
 * @returns {string}
 */
export const encrypt = (value) => {
  return encryptFernetSync(value, ENCRYPT_KEY)
}

/**
 * 解密
 * @param tokenBase64
 * @returns {string}
 */
export const decrypt = (tokenBase64) => {
  const { plaintext } = decryptFernetSync(tokenBase64, ENCRYPT_KEY)
  return plaintext || ''
}
